import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Box, Button, Container, makeStyles } from '@material-ui/core';
import mainStyles from '@/assets/js/mainStyles.js';
import usePage from '@/hooks/usePage.js';
import Request from '@/helpers/request.js';

const useStyles = makeStyles(mainStyles);

const Implementation = () => {
  const classes = useStyles();
  const history = useHistory();
  const { id } = useParams();
  const { setTitle } = usePage();
  const [module, setModule] = useState({});

  useEffect(async () => {
    const fetchModule = async () => {
      const response = await Request.get(`/p3d2-modules/${id}`);
      setModule(response);
    };
    setTitle('Modules');
    await fetchModule();
  }, []);
  return (
    <Container maxWidth="md">
      <Box className={classes.contentMW}>
        <div className={classes.secTitle}>
          <span>{module?.title} </span>
        </div>
        <Box align="center" className={classes.flexBoxColumn}>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`implementation/logistics`)}
            variant="outlined"
            size="large"
          >
            Logistique
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`implementation/unfolding`)}
            variant="outlined"
            size="large"
          >
            Dépliage
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`implementation/maintenance`)}
            variant="outlined"
            size="large"
          >
            Mise en place sur batiment
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`implementation/folding`)}
            variant="outlined"
            size="large"
          >
            Repliage
          </Button>
          <Button
            className={classes.outlinedBtn}
            onClick={() => history.push(`implementation/setting`)}
            variant="outlined"
            size="large"
          >
            Réglage
          </Button>
          <Button
            className={classes.mainBtn}
            onClick={() => window.open('https://www.sateco.fr/fr/faq.html')}
            variant="outlined"
            size="large"
          >
            FAQ
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default Implementation;
